import React, { useEffect, useState, useRef } from "react";
// jquery
import $ from "jquery";
// React Bootstrap
import { Form, Navbar, Col, InputGroup } from "react-bootstrap";
// Componentes
import TablaVidaReligiosa from "../vistas/TablaVidaReligiosa";
// Custom spinner
import CustomSpinner from "../../generic/CustomSpinner";
// Styled Components
import styled from "styled-components";
// Hooks
import { useIsMount } from "../../hooks/UseIsMount";
import useObserver from "../../hooks/UseObserver";
// Contexto
import { tipoCargosContext } from "../../../contexto";

const CustomNavBar = styled(Navbar)`
  min-width: 200px;
  padding: 0px;
  margin: 0px;
  padding-top: 10px;
`;

const CustomTable = styled.div`
  position: relative;
  overflow: auto;
  max-height: 500px;
`;

const VidaReligiosa = ({ idUsuario }) => {
  // Spinner
  const [loading, setLoading] = useState(false);

  // Vida religiosa del usuario
  const [vidaReligiosa, setVidaReligiosa] = useState([]);

  // Filtros, paginación y observador
  const [page, setPage] = useState(1); // Página por la que va
  const [lastPageReached, setLastPageReached] = useState(false); // ultima pagina alcanzada
  const [reload, setReload] = useState(false); // Reload para recargar el observador
  const [isActive, setIsActive] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filtroGrupoCargo, setFiltroGrupoCargo] = useState("");
  const isMount = useIsMount(); // Se renderiza por primera vez?
  const scrollingDiv = useRef(null); // Div que contendrá el scroll

  // Resetea el explorador con los filtros actuales
  const resetVidaReligiosa = () => {
    setPage(1);
    setReload(!reload);
  };

  // Para volver a pedir los datos cuando cambia algun filtro
  useEffect(() => {
    if (!isMount) {
      resetVidaReligiosa();
    }
    scrollingDiv.current.scrollTop = 0;
  }, [isActive, startDate, endDate, filtroGrupoCargo]);

  useEffect(() => {
    handleGetVidaReligiosa();
  }, [reload]);

  // **************************************************** GET ************************************************
  // Obtiene la vida religiosa de un usuario
  const getVidaReligiosa = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/usuarios/${idUsuario}/cargos?page=${page}&isActive=${isActive}&startDate=${startDate}&endDate=${endDate}&grupoCargo=${filtroGrupoCargo}`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Manejador de la respuesta de la vida religiosa
  const handleGetVidaReligiosa = (addToExisting = false) => {
    setPage(page + 1);
    setLoading(true);
    getVidaReligiosa()
      .then((response) => {
        if (response.totalPages <= page) {
          setLastPageReached(true);
        } else {
          setLastPageReached(false);
        }
        if (addToExisting) {
          setVidaReligiosa([...vidaReligiosa, ...response.items]);
        } else {
          setVidaReligiosa(response.items);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // **************************************************** UTILS ************************************************
  // Para manejar el cambio de fecha de los filtros
  const handleChangeStartDate = (e) => {
    setStartDate(e.target.value);
    setIsActive(false);
  };

  // Para manejar el cambio final de los filtros
  const handleChangeEndDate = (e) => {
    setEndDate(e.target.value);
    setIsActive(false);
  };

  // Para manejar el select de las etapas vida religiosa activas
  const handleChangeIsActive = (e) => {
    setStartDate("");
    setEndDate("");
    setIsActive(!isActive);
  };

  // Para manejar el filtro del cargo
  const handleChangeCargo = (e) => {
    setFiltroGrupoCargo(e.target.value);
  };

  // **************************************************** OBSERVADOR ************************************************
  const loadMore = async () => {
    if (!lastPageReached && !loading) {
      handleGetVidaReligiosa(true);
    }
  };

  const target = useRef(null);

  useObserver(
    loadMore,
    {
      root: scrollingDiv.current,
      rootMargin: "0px",
      threshold: 1,
    },
    target,
    vidaReligiosa
  );

  return (
    <div className="position-relative">
      <CustomSpinner animation={"border"} loading={loading} />
      {/* Filtros */}
      <CustomNavBar expand="md">
        {/* Cuando se hace pequeña la pantalla */}
        <Navbar.Toggle>
          <span className="align-text-bottom"> Filtros</span>
        </Navbar.Toggle>
        <Navbar.Collapse>
          <Form as="div" className="w-100">
            <Form.Row>
              <Form.Group as={Col} xs={12} md>
                <InputGroup className="mr-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text>{"Servicios"}</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control as="select" onChange={handleChangeCargo} value={filtroGrupoCargo} custom>
                    <option value="">Todos</option>
                    {Object.keys(tipoCargosContext).length &&
                      Object.keys(tipoCargosContext).map((keyCargo) => {
                        return (
                          <option key={keyCargo} value={keyCargo}>
                            {tipoCargosContext[keyCargo]}
                          </option>
                        );
                      })}
                  </Form.Control>
                </InputGroup>
              </Form.Group>

              <Form.Group as={Col} xs={12} md>
                <InputGroup className="mr-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text>{"Fecha inicio"}</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control type="date" max={endDate} value={startDate} onChange={handleChangeStartDate} />
                </InputGroup>
              </Form.Group>
              <Form.Group as={Col} xs={12} md>
                <InputGroup className="mr-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text>{"Fecha de fin"}</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control type="date" min={startDate} value={endDate} onChange={handleChangeEndDate} />
                </InputGroup>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} xs={12} md>
                <InputGroup>
                  <Form.Group>
                    <Form.Check type="checkbox" label={`Servicios activos`} defaultChecked={isActive} checked={isActive} onClick={handleChangeIsActive} />
                  </Form.Group>
                </InputGroup>
              </Form.Group>
            </Form.Row>
          </Form>
        </Navbar.Collapse>
      </CustomNavBar>

      <CustomTable ref={scrollingDiv}>
        <TablaVidaReligiosa vidaReligiosa={vidaReligiosa} />
        <br ref={target} id="observable" />
      </CustomTable>
    </div>
  );
};

export default VidaReligiosa;
